interface ServiceHeroProps {
  title: string;
  subtitle: string;
  description: string;
  heroImage?: string;
}

export default function ServiceHero({ title, subtitle, description }: ServiceHeroProps) {
  return (
    <section className="relative h-[320px] md:h-[420px] flex items-center justify-center overflow-hidden bg-black">
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, #f67f19 0%, transparent 50%), radial-gradient(circle at 80% 50%, #f67f19 0%, transparent 50%)' }}></div>
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto pt-20">
        <p className="text-[#f67f19] font-semibold text-sm uppercase tracking-widest mb-3">{subtitle}</p>
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black mb-4 leading-tight">{title}</h1>
        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">{description}</p>
      </div>
    </section>
  );
}
